import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12 px-4">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <h3 className="text-2xl font-bold mb-4">YupiSoft</h3>
          <p className="text-gray-400">
            Soluciones tecnológicas para negocios peruanos.
          </p>
        </div>
        <div>
          <h4 className="font-semibold mb-4">Productos</h4>
          <ul className="space-y-2 text-gray-400">
            <li>Yupi ventas pro (stock e inventario)</li>
            <li>Yupi citas (agenda tus citas)</li>
            <li>Yupi Rest (gestiona tu restaurante)</li>
            <li>Soluciones a medida</li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-4">Empresa</h4>
          <ul className="space-y-2 text-gray-400">
            <li>Nosotros</li>
            <li>Clientes</li>
            <li>Contacto</li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-4">Contacto</h4>
          <ul className="space-y-2 text-gray-400">
            <li>contacto@yupisoft.lat</li>
            <li>+51 972 843 376</li>
            <li>Lima, Perú</li>
          </ul>
        </div>
      </div>
      <div className="max-w-6xl mx-auto pt-8 mt-8 border-t border-gray-800 text-center text-gray-500">
        <p>© 2025 YupiSoft. Todos los derechos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;